import { __ } from '@wordpress/i18n';
import { check, close } from '@wordpress/icons';
import { registerBlockVariation } from '@wordpress/blocks';

const variations = [
	{
		name: 'success-verification',
		isDefault: true,
		title: __( 'Success Verfication Output' ),
		description: __(
			'Verification output that should be displayed when the token is valid.'
		),
		icon: check,
		attributes: { type: 'success' },
		isActive: ( blockAttributes, variationAttributes ) => {
			return blockAttributes.type === variationAttributes.type;
		},
		scope: [],
	},
	{
		name: 'failure-verification',
		title: __( 'Failure Verfication Output' ),
		description: __(
			'Verification output that should be displayed when the token is invalid.'
		),
		icon: close,
		attributes: { type: 'failure' },
		isActive: ( blockAttributes, variationAttributes ) => {
			return blockAttributes.type === variationAttributes.type;
		},
		scope: [],
	},
];

variations.forEach( ( variation ) => {
	registerBlockVariation( 'web3coingate/verification-output', variation );
} );
